import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const IpdObjectInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IpdObjectPrefix = styled.span`
  font-weight: 600;
  color: ${colors.gray900};
  font-size: 14px;
  white-space: nowrap;
`

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${colors.status.error.text};
`
